import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

import { Toolbar, Breadcrumbs } from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";

import User from "../Menus/User";
import Notifications from "../Menus/Notifications";

const nonLinks = ["studio"];

export default function Header() {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const router = useRouter();

  useEffect(() => {
    setBreadcrumbs(router.asPath.split("/").filter(Boolean));
  }, [router.asPath]);

  const getLink = (inx) => {
    const path = breadcrumbs.slice(0, inx + 1).join("/");
    return path ? `/${path}` : "/";
  };

  return (
    <div className="flex justify-between">
      <Toolbar>
        <Breadcrumbs
          sx={{
            flexGrow: 1,
            color: "inherit",
            fontSize: "0.875rem",
            hidden: "md:flex",
          }}
          separator={<DoubleArrowIcon fontSize="inherit" />}
        >
          <span className="capitalize hover:underline">
            <Link href={"/"}>Channel</Link>
          </span>

          {breadcrumbs.map((crumb, index) => (
            <span
              key={index}
              className={`capitalize ${
                breadcrumbs.length === index + 1 || nonLinks.includes(crumb)
                  ? ""
                  : "hover:underline"
              }`}
            >
              {nonLinks.includes(crumb) ? (
                crumb
              ) : (
                <Link href={getLink(index)}>{crumb}</Link>
              )}
            </span>
          ))}
        </Breadcrumbs>
      </Toolbar>

      <Toolbar>
        <Notifications />
        <User />
      </Toolbar>
    </div>
  );
}
